export { SharedDataAccessQuotesModule } from './lib/shared-data-access-quotes.module';
export { QuotesService } from './lib/services/quotes.service';
export {
  Quotes2Service,
  RawPatchQuoteResponse,
} from './lib/services/quotes2.service';
export * as SharedQuotesSelectors from './lib/+state/quotes.selectors';
export {
  LocalActions as QuoteEffectsActions,
  QuotesEffectsActions as QuotesEffectsActionTypes,
} from './lib/+state/actions';
